<template>
    <hts-card>
        <h3>
            Cài đặt nhắc nhở hết hạn cho:
        </h3>

        <hts-form @submit="handleSubmit">
            <hts-form-checkbox
                v-model="formData.reminders"
                label=""
                value-key="value"
                :items="listRadioFragileTypes" />

            <div
                v-if="formData.reminders.includes('contract') && formData.reminderDetail.contract"
                class="mt-5">
                <h3>
                    Hợp đồng
                </h3>

                <div class="sm:flex gap-10 items-end">
                    <hts-form-input
                        v-model="formData.reminderDetail.contract.reminderAdvance"
                        label="Nhắc nhở trước"
                        required
                        type="number"
                        number-interger>
                        <template #suffix>
                            Ngày
                        </template>
                    </hts-form-input>

                    <hts-form-input
                        v-model="formData.reminderDetail.contract.repeat"
                        label="Nhắc nhở lại sau"
                        type="number"
                        number-interger>
                        <template #suffix>
                            Ngày
                        </template>
                    </hts-form-input>
                </div>
            </div>

            <div
                v-if="formData.reminders.includes('healthCheck') && formData.reminderDetail.healthCheck"
                class="mt-5">
                <h3>
                    Khám sức khỏe
                </h3>

                <div class="sm:flex gap-10 items-end">
                    <hts-form-input
                        v-model="formData.reminderDetail.healthCheck.reminderAdvance"
                        label="Nhắc nhở trước"
                        required
                        type="number"
                        number-interger>
                        <template #suffix>
                            Ngày
                        </template>
                    </hts-form-input>

                    <hts-form-input
                        v-model="formData.reminderDetail.healthCheck.repeat"
                        label="Nhắc nhở lại sau"
                        type="number"
                        number-interger>
                        <template #suffix>
                            Ngày
                        </template>
                    </hts-form-input>
                </div>
            </div>

            <div
                v-if="formData.reminders.includes('license') && formData.reminderDetail.license"
                class="mt-5">
                <h3>
                    Giấy phép lái xe
                </h3>

                <div class="sm:flex gap-10 items-end">
                    <hts-form-input
                        v-model="formData.reminderDetail.license.reminderAdvance"
                        label="Nhắc nhở trước"
                        required
                        type="number"
                        number-interger>
                        <template #suffix>
                            Ngày
                        </template>
                    </hts-form-input>

                    <hts-form-input
                        v-model="formData.reminderDetail.license.repeat"
                        label="Nhắc nhở lại sau"
                        type="number"
                        number-interger>
                        <template #suffix>
                            Ngày
                        </template>
                    </hts-form-input>
                </div>
            </div>

            <hts-form-button
                class="mt-20"
                icon-position="right"
                color="primary"
                type="submit">
                {{ $t('labels.save') }}
            </hts-form-button>
        </hts-form>
    </hts-card>
</template>
<script setup lang="ts">
const store = $store()

const formData = ref({
  reminders: [] as string[],
  reminderDetail: {
    contract: {
      reminderAdvance: 30,
      repeat: null
    },
    healthCheck: {
      reminderAdvance: 30,
      repeat: null
    },
    license: {
      reminderAdvance: 30,
      repeat: null
    }
  } as { [key: string]: any }
})

onMounted(() => {
  const globalSettingsInformation = store.globalSettings.getGlobalSettings

  const reminders = globalSettingsInformation.partner.driver.reminders

  formData.value.reminders = reminders

  reminders.forEach((item: string) => {
    formData.value.reminderDetail[item] = globalSettingsInformation.partner.driver.reminderDetail[item]
  })
})

const listRadioFragileTypes = [
  { value: 'contract', label: $t('labels.contract') },
  { value: 'healthCheck', label: $t('labels.healthCheck') },
  { value: 'license', label: 'Giấy phép lái xe' }
]

const submitForm = () => {
  const api = $urlPartner.settings.updatePartnerSettings
  const data = {
    type: 'driver',
    ...formData.value
  }
  $api(api, { body: { ...data } })
    .then((dataRes) => {
      if (!dataRes) {
        return true
      }
      process.client && $toast().success($t('notifications.updateSuccess'))
    })
    .catch(() => {
      process.client && $toast().error($t('notifications.updateError'))
    })
}

const handleSubmit = $lodash.debounce(submitForm, 500)
</script>
